const urlPrettier = (str: string) =>
  str
    .split('/')
    .filter(word => word.match(/\w+/))
    .join('/')

export default urlPrettier
